<div class="fx-column" id="trendChart">

  <div class="fx-row-center-center" id="options">
    <form [formGroup]="lineSelectForm">
      <mat-form-field>
          <mat-select placeholder="Line Select" formControlName="lines" multiple>
            <mat-option *ngFor="let lines of lineListElements$ | async" [value]="lines">{{lines}}</mat-option>
          </mat-select>
        </mat-form-field>
        <button type="button"
        mat-raised-button
        color ="primary"
        (click)="changeLinesDisplayed()" type="button">
        Submit
        </button>
    </form>
  </div>

    <div class="fx-row-center-center" id="options">
      <div class="date-row">
        <app-date-selection (dateChange)="onDateChange($event)"></app-date-selection>
      </div>
    </div>
    
      <ng-template #footerTemplate>
        <button class="btn btn-primary btn-sm btn-xs float-left" (click)="getSeverityTrendData()">Submit</button>
        <button class="btn btn-secondary btn-sm btn-xs float-right" (click)="this.isCalVisible = !this.isCalVisible">Close</button>
      </ng-template>
      
        
      <div id="trendChart" *ngIf="showChart"  class="chart-main">
        <div echarts [options]="chartOption" class="trend-echart"></div>
      </div>

      <div *ngIf="!showChart" class="no-data">
        <h5>No Data</h5>
      </div>
    </div>
    
